module.exports = __webpack_public_path__ + "media/files/sample_eligibility_file_old-5ef2db1196fc39ba9d5af7d8da69170c.xls";